<!--
  Сборка/деплой: правка здесь не попадёт на сайт без пересборки бандла.
  → cd api && ./build-calc.sh --no-install && docker compose restart php
  Процесс и грабли opcache: api/app/views/calculator/repo/README.md
  Активируется через window.useCalculatorTst = 1 (см. App.vue.beforeMount).
-->
<template>
  <div class="calculator calculator--tst" ref="calculator">
    <Popup ref="Popup"/>
    <PopupRef ref="PopupRef"/>
    <div class="page-content">
      <div class="page-content-wrapper">
        <div class="options-wrapper" style="overflow: hidden;">
          <div class="flat-options" :class="{'cottage-options': isCottage}">
            <div v-if="!isCottage" class="room-number">
              <div class="room-number__title options__title">
                {{ $store.state._(`Количество комнат`) }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                        style="margin-top: -2px;"
                        color="#d6d0cd">
                      mdi-help-circle
                    </v-icon>
                  </template>
                  <span>
                    <div v-for="(interval, rooms) in flatSize" :key="rooms" style="color: #FFFFFF">
{{ rooms }} {{ $store.state._(`комн.`) }} - {{ interval[0] }}-{{ interval[1] }} {{ $store.state._(`м²`) }}<br>
                    </div>
                  </span>
                </v-tooltip>
              </div>
              <div class="room-number-options">
                <div
                    @click="options.address.flattype = value; calculate()"
                    :class="options.address.flattype === value ? 'room-number-options__option--selected' : ''"
                    class="room-number-options__option" v-for="(room_option, value) in room_options" :key="value">
                  {{ room_option }}
                </div>
              </div>
              <div class="sqr-wrapper" v-if="options.address.flattype === '5'">
                <v-text-field
                    class="sqr__value"
                    placeholder="150"
                    outlined
                    rounded
                    v-model="options.address.sqr"
                    @change="calculate()"
                    autocomplete="off"
                />
                <div class="sqr__label">{{ $store.state._(`м²`) }}</div>
              </div>
            </div>
            <div class="cleantypes flex-grow-1">
              <div class="cleantypes__title options__title">{{ $store.state._(`Тип уборки`) }}</div>
              <div class="cleantypes-options ceo-types-grid">
                <button
                    type="button"
                    v-for="(type, value) in cleantype_options"
                    :key="value"
                    class="ceo-type-btn"
                    :class="{ 'ceo-type-btn--selected': options.type === value }"
                    @click="applyCleanType(Object.keys(cleantype_options).indexOf(value))"
                >{{ type.title }}<img
                    class="ceo-type-btn__hint"
                    src="/dist/images/calculator/icon_question_grey.svg"
                    alt=""
                    @click.stop="showTypesModal"
                /></button>
              </div>
            </div>
            <div class="sqr-wrapper" v-if="isCottage">
              <v-text-field
                  class="sqr__value"
                  placeholder="150"
                  outlined
                  rounded
                  v-model="options.address.sqr"
                  @change="calculate()"
                  autocomplete="off"
              />
              <div class="sqr__label">{{ $store.state._(`м²`) }}</div>
            </div>
          </div>

          <div class="additional-services">
            <div class="options__title d-flex mb-4 align-center">
              <span>{{ $store.state._(`Дополнительные услуги`) }}</span>
              <v-btn class="ml-auto clear-btn" elevation="0" @click="clearForm">Очистить</v-btn>
            </div>
            <div class="additional-services--wrapper overflow-hidden">
              <AdditionalService :options="options"
                                 v-for="(service, index) in showedAll ? additional_services : additional_services.slice(0, 3)"
                                 :key="index" :service="service"
                                 @on-change-value="calculate"/>
              <template v-if="dryCleaningServicesEnabled">
                <AdditionalService :service="dry_service" :options="options" :is_dry_service="true"
                                   :dry_services_count="countSelectedDryServices()"/> <!--Химчистка-->
                <template v-if="+options['him']">
                  <AdditionalService v-for="dry_service in dry_cleaning_services"
                                     @on-change-value="calculate"
                                     :key="dry_service.key" :service="dry_service"
                                     :options="options"
                                     :is_dry_service="true"
                                     :selected_dry_service="selected_dry_service"
                                     @on-dry-service-select="onDryServiceSelected">
                    <template #default>
                      <div class="sub-services" v-if="selected_dry_service === dry_service.key">
                        <AdditionalService v-for="dry_service_item in dry_service.items" :options="options.services"
                                           @on-change-value="calculate"
                                           :is_dry_service_item="true"
                                           :service="dry_service_item" :key="dry_service_item.form_name">
                          <AdditionalService v-if="+options.services[dry_service_item.form_name]"
                                             @on-change-value="calculate"
                                             :is_leather="true"
                                             :options="options.services"
                                             :service="{
                                             form_name: dry_service_item.form_name+'_him_koja',
                                             name: $store.state._(`Изделие из кожи`), price:30,units:'',units_after_price:'%'}"/>
                        </AdditionalService>
                      </div>
                    </template>
                  </AdditionalService>
                </template>
              </template>
              <div class="collapse-btn-wrapper">
                <v-btn
                    class="v-btn-main" @click="showedAll = !showedAll">
                  {{
                    !showedAll ? $store.state._(`+ Ещё ${additional_services.length - 4} опций`) : $store.state._(`Свернуть`)
                  }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="side-wrapper total-wrapper" v-if="order_step === 0">
          <div class="total">
            <!-- /tst мобайл: компактная плашка цены по Figma (большая сумма + бейдж + мета-строка). Десктоп скрывает её через CSS. -->
            <div class="total__tst-compact" v-if="!calculate_loading">
              <div class="total__tst-row">
                <span class="total__tst-sum">{{ headlineRegularPrice ? sumSeparator(headlineRegularPrice) : 0 }} {{ countrySettings.currency }}</span>
                <span v-if="calculatedProps.firstPromoAvailable" class="ceo-discount-badge total__tst-badge">{{ firstPromoBadgeText }}</span>
              </div>
              <div class="total__tst-meta">{{ calculatedProps.duration }} · {{ cleantype_options[options.type].title }} · {{ roomCountLabel }}</div>
            </div>
            <p class="total__desc">
              <template v-if="(+options.address.flattype) === 1">
                <template v-if="(+options.address.wcNum) === 1">
                  {{
                    $store.state._(`Уборка квартиры с _rooms_ жилой комнатой и одним санузлом`).split('_rooms_').join(room_options[1])
                  }}
                </template>
                <template v-else>
                  {{
                    $store.state._(`Уборка квартиры с _rooms_ жилой комнатой и _count_ санузлами`).split('_rooms_').join(room_options[1]).split('_count_').join(options.address.wcNum)
                  }}
                </template>
              </template>
              <template v-else>
                <template v-if="(+options.address.wcNum) === 1">
                  {{
                    $store.state._(`Уборка квартиры с _rooms_ жилыми комнатами и одним санузлом`).split('_rooms_').join(room_options[+options.address.flattype])
                  }}
                </template>
                <template v-else>
                  {{
                    $store.state._(`Уборка квартиры с _rooms_ жилыми комнатами и _count_ санузлами`).split('_rooms_').join(room_options[+options.address.flattype]).split('_count_').join(options.address.wcNum)
                  }}
                </template>
              </template>
            </p>
            <div class="selected-services">
              <div class="selected-service"
                   v-for="service in additional_services.filter(serv=>parseInt(options[serv.form_name]) > parseInt(serv.form_value))"
                   :key="service.form_name"
              >
                <div class="name">{{ service.name }}</div>
                <div class="price" v-if="service.form_name === 'address.wcNum'">
                  {{
                    sumSeparator(Number(options.type == 'remont' && service.priceRemont ? service.priceRemont : service.price) * options[service.form_name] - Number(options.type == 'remont' && service.priceRemont ? service.priceRemont : service.price))
                  }} {{ service.units_after_price }}
                </div>
                <div class="price" v-else-if="service.units_after_price === '%'">
                  {{
                    calculatedProps.additionServices ? calculatedProps.additionServices[service.form_name] : ''
                  }}{{ countrySettings.currency }}
                </div>
                <div class="price" v-else>{{
                    sumSeparator(Number(options.type == 'remont' && service.priceRemont ? service.priceRemont : service.price) * options[service.form_name])
                  }} {{
                    service.units_after_price
                  }}
                </div>
                <v-btn class="v-btn-delete-service" icon
                       @click="options[service.form_name] = 0; $forceUpdate(); calculate()">
                  <v-icon size="16" color="#333">mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="selected-service"
                   v-for="service in dry_cleaning_services.flatMap(dry_serv=>dry_serv.items).filter(serv=>+options.services[serv.form_name] > +serv.form_value)"
                   :key="service.key">
                <div class="name">{{ service.name }}</div>
                <div class="price" v-if="service.units_after_price === '%'">
                  {{
                    calculatedProps.additionServices ? calculatedProps.additionServices[service.form_name] : ''
                  }}{{ countrySettings.currency }}
                </div>
                <div class="price" v-else>{{
                    sumSeparator(+service.price * +options.services[service.form_name])
                  }} {{
                    service.units_after_price
                  }}
                </div>
                <v-btn class="v-btn-delete-service" icon
                       @click="options.services[service.form_name] = 0; $forceUpdate(); calculate()">
                  <v-icon size="16" color="#333">mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="discount-wrapper"
                 v-if="parseInt(calculatedProps.totalCost) > parseInt(calculatedProps.totalPay) && calculatedProps.promoInfo && !options.promo">
              <span>{{ calculatedProps.promoInfo.title }}</span>
            </div>
            <div class="total-sum-wrapper">
              <div class="total-sum total-sum-wrapper__title align-self-start">{{ $store.state._(`К оплате`) }}</div>
              <div v-if="calculate_loading" class="total-sum-wrapper__sum skeleton-loader"
                   style="height: 38px; width: 105px; border-radius: 8px"/>
              <div v-else class="total-sum-wrapper__sum">
                <span class="d-block">{{
                    calculatedProps.totalCost ? sumSeparator(calculatedProps.totalCost) : 0
                  }} {{ countrySettings.currency }}</span>
              </div>
            </div>
            <div class="duration-wrapper" v-if="calculatedProps.anotherCurrency" style="justify-content: end;">
              {{ calculatedProps.anotherCurrency }}
            </div>
            <div class="duration-wrapper" v-if="calculatedProps.bonus">
              {{ $store.state._(`Будет списано 100 бонусов`).split('100').join(calculatedProps.bonus) }}
            </div>
            <div class="duration-wrapper">
              <div>{{ $store.state._(`Примерное время уборки`) }}</div>
              <div v-if="calculate_loading" class="skeleton-loader"
                   style="width: 72px; height: 21px;border-radius: 24px"></div>
              <div v-else>
                {{ calculatedProps.duration }}
              </div>
            </div>
            <div class="duration-wrapper"
                 v-if="calculatedProps.workersCount && ![0,1].includes(+calculatedProps.workersCount)">
              <div>{{ $store.state._(`Ориентировочное кол-во клинеров`) }}</div>
              <div v-if="calculate_loading" class="skeleton-loader"
                   style="width: 60px; height: 21px;border-radius: 24px"></div>
              <div v-else>
                {{ calculatedProps.workersCount }}
              </div>
            </div>
            <div v-if="calculatedProps.firstPromoAvailable" class="ceo-discount-badge">{{ firstPromoBadgeText }}</div>
            <!-- /tst (Figma #23): «Высокий спрос» строим на фронте из koef. Бэкенд
                 не заполняет koefObj.title (ABTest::getDatetimeCalc хардкодом =1
                 пропускает ветку в Order.php), поэтому текст и копирайт — здесь. -->
            <div class="high-demand-wrapper"
                 v-if="calculatedProps.koef > 1 || calculatedProps.koef < 1">
              {{
                calculatedProps.koef > 1
                  ? `${$store.state._('Высокий спрос! Действует повышенный тариф')} (+${Math.round(calculatedProps.koef * 100 - 100)}%).`
                  : `${$store.state._('Скидка')}! (-${Math.abs(Math.round(calculatedProps.koef * 100 - 100))}%)`
              }}

              <span v-if="calculatedProps.koef > 1">{{ $store.state._(`Закажите на вторник или среду, там часто бывают скидки!`) }}</span>
              <span v-else-if="calculatedProps.koefObj.subtitle">{{ calculatedProps.koefObj.subtitle }}</span>
            </div>
          </div>
          <div class="order-info">
            <v-form ref="form_orderInfo">
              <v-text-field
                  autocomplete="tel"
                  :rules="[v=>!!v || $store.state._(`Укажите телефон`),
                v=>v && v.length >= phoneMaskTst.length || $store.state._(`Укажите телефон`),
                 ]"
                  validate-on-blur
                  class="phone phone--tst"
                  @change="calculate"
                  v-model="phoneProxy"
                  outlined
                  type="tel"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  name="phone"
                  rounded
                  @focus="onPhoneFocus()"
                  v-mask="phoneMaskTst"
                  :placeholder="phonePlaceholderTst"
              >
                <template #prepend-inner>
                  <span class="phone--tst__prefix">+7</span>
                </template>
              </v-text-field>
              <v-text-field
                  autocomplete="given-name"
                  :rules="[v => isReducedFlow || !!v || $store.state._(`Укажите имя`)]"
                  v-model="options.client.name"
                  outlined
                  name="name"
                  rounded
                  :placeholder="$store.state._(`Имя`)"/>
              <div class="date-and-time-wrapper"
                   :class="isNewDatetimePicker?'new_date_time_picker':'old_datetime_picker'">
                <v-menu
                    :left="!!(isNewDatetimePicker && $vuetify.breakpoint.width <= 960)"
                    :top="!!(isNewDatetimePicker && $vuetify.breakpoint.width <= 960)"
                    v-model="menu_date"
                    :close-on-content-click="false"
                    :close-on-click="!timeDisabledModalOpened"
                    min-width="auto"
                    :content-class="isNewDatetimePicker && $vuetify.breakpoint.width <= 960 ? 'datetime-modal-content' : ''"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        @click="menu_date=true"
                        :rules="[]"
                        autocomplete="off"
                        v-bind:value="(options.datetimecleanObj.date && (!isNewDatetimePicker || options.datetimecleanObj.time)) ? `${new Date(options.datetimecleanObj.date).toLocaleDateString($store.state.local, {
          month: 'short', day: 'numeric', weekday: 'short' })}${isNewDatetimePicker ? `, ${$store.state._('в')} ${options.datetimecleanObj.time}` : ''}` : ''"
                        class="date"
                        readonly
                        :placeholder="$store.state._(isNewDatetimePicker ? 'Дата и время' :`Дата уборки`)"
                        outlined
                        rounded
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-chevron-down"
                        @click:append="menu_date=true"
                    />
                  </template>
                  <div v-if="isNewDatetimePicker && $vuetify.breakpoint.width <= 960" class="mobile-datetime-picker">
                    <v-btn icon class="mobile-datetime-picker-close" @click="menu_date = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span class="picker-label">{{ $store.state._('Дата') }}</span>
                    <div class="date-slots-container" v-if="datetimeProps.dateSlots.length">
                      <div class="date-slot" :class="{'selected': options.datetimecleanObj.date === slot.date}"
                           v-for="slot in datetimeProps.dateSlots" :key="slot.date"
                           :style="`border-color: ${slot.color}`"
                           @click="selectDateMobile(slot.date)">
                        <span>{{
                            `${new Date(slot.date).toLocaleDateString($store.state.local, {day: 'numeric'})}`
                          }}</span>
                        <span>{{
                            `${new Date(slot.date).toLocaleDateString($store.state.local, {weekday: 'short'})}`
                          }}</span>
                      </div>
                    </div>
                    <span class="picker-label">{{ $store.state._('Время') }}</span>
                    <template v-if="calculate_date_loading">
                      <div class="time-picker-container">
                        <div class="time-picker-outer" v-for="(interval, i) in [[8], [7]]" :key="i">
                          <template v-if="interval.length">
                            <span class="time-picker-label">{{ $store.state._(i === 0 ? 'Утро' : 'День') }}</span>
                            <div class="time-slot-items">
                              <div class="time-slot-item-container" v-for="slot in 8 - i" :key="slot">
                                <div class="time skeleton-loader"></div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                    <div class="time-picker-container">
                      <template v-if="!calculate_date_loading">
                        <div class="time-picker-outer" v-for="(interval, i) in datetimeProps.timeSlots" :key="i">
                          <template v-if="interval.length">
                            <span class="time-picker-label">{{ $store.state._(i === 0 ? 'Утро' : 'День') }}</span>
                            <div class="time-slot-items">
                              <div class="time-slot-item-container" v-for="slot in interval" :key="slot.time"
                                   @click="chooseTime(slot)">
                                <div class="time" :class="{'selected': slot.time === options.datetimecleanObj.time}"
                                     :style="`border-color: ${slot.color || '#C8C6C6'};
                                   color: ${slot.time === options.datetimecleanObj.time ? '#fff' : slot.fontColor || '#333'}`">
                                  {{ slot.time }}
                                </div>
                                <div class="percent" :style="`color: ${slot.color || '#333'}`">{{ slot.percent }}</div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                      <div class="mobile-datetime-picker-actions">
                        <v-btn class="v-btn-main time-picker-button" @click="menu_date = false">
                          {{ $store.state._('Продолжить') }}
                          <span class="old-sum d-block"
                                v-if="parseInt(calculatedProps.totalCost) > parseInt(calculatedProps.totalPay)"
                          >{{
                              calculatedProps.totalCost ? sumSeparator(calculatedProps.totalCost) : 0
                            }} {{ countrySettings.currency }}</span>

                          <span class="d-block">{{
                              calculatedProps.totalPay ? sumSeparator(calculatedProps.totalPay) : 0
                            }} {{ countrySettings.currency }}</span>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <v-date-picker
                      v-else
                      :events="datetimeProps.dateSlots.map(a=>a.date)"
                      :event-color="(date)=>datetimeProps.dateSlots.find(a=>a.date===date) ? datetimeProps.dateSlots.find(a=>a.date===date).color : ''"
                      no-title
                      reactive
                      v-model="options.datetimecleanObj.date"
                      locale="ru"
                      width="334px"
                      first-day-of-week="1"
                      @input="onDateChange()"
                      :min="new Date().toISOString()"
                      @change="calculate()"
                  >
                    <template #default v-if="datetimeProps.dateSlots.length">
                      <div class="time-picker-container">
                        <div v-if="calculate_date_loading">
                          <div class="time-slot-items">
                            <div class="time-slot-item-container" v-for="i in 11" :key="i">
                              <div class="time skeleton-loader"></div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="time-slot-items">
                          <div class="time-slot-item-container" v-for="slot in timeSlots" :key="slot.time"
                               @click="chooseTime(slot)">
                            <div class="time" :class="{'selected': slot.time === options.datetimecleanObj.time}"
                                 :style="`border-color: ${slot.color || '#C8C6C6'};
                                 color: ${slot.time === options.datetimecleanObj.time ? '#FFF' : slot.fontColor || '#333'}`">
                              {{ slot.time }}
                            </div>
                            <div class="percent" :style="`color: ${slot.color || '#333'}`">{{ slot.percent }}</div>
                          </div>
                        </div>
                        <v-btn class="v-btn-main time-picker-button" @click="menu_date = false">
                          {{ $store.state._('Продолжить') }}
                          <span class="old-sum d-block"
                                v-if="parseInt(calculatedProps.totalCost) > parseInt(calculatedProps.totalPay)"
                          >{{
                              calculatedProps.totalCost ? sumSeparator(calculatedProps.totalCost) : 0
                            }} {{ countrySettings.currency }}</span>

                          <span class="d-block">{{
                              calculatedProps.totalPay ? sumSeparator(calculatedProps.totalPay) : 0
                            }} {{ countrySettings.currency }}</span>
                        </v-btn>
                      </div>
                    </template>
                  </v-date-picker>
                </v-menu>
                <span class="high-demand"
                      v-if="calculatedProps.koef > 1 && calculatedProps.koefObj.titleSmall && $vuetify.breakpoint.width < 600">{{
                    calculatedProps.koefObj.titleSmall
                  }}</span>
                <span class="discount"
                      v-if="calculatedProps.koef < 1  && $vuetify.breakpoint.width < 600">{{
                    $store.state._(`Вам повезло, низкий спрос! Дешевле на`)
                  }} {{
                    Math.abs(calculatedProps.koef * 100 - 100)
                  }}%</span>
                <v-select
                    v-if="!isNewDatetimePicker"
                    style="min-width: 130px"
                    ref="time_select"
                    :rules="[]"
                    autocomplete="off"
                    v-model="options.datetimecleanObj.time"
                    class="time"
                    :items="availableTimes"
                    outlined
                    rounded
                    :placeholder="$store.state._(`Выберите время`)"
                    append-icon="mdi-chevron-down"
                    :no-data-text="$store.state._(`В выбранную дату нет доступного времени`)"
                    @change="calculate">
                  <template v-slot:item="{item}">
                    <div class="d-flex justify-space-between px-4" style="width: 100%">
                      <div>{{ item }}</div>
                      <v-icon color="#FF5834"
                              v-if="koefsDate[item.split(':')[0]] > 0">mdi-arrow-up
                      </v-icon>
                      <v-icon color="#21BEC7"
                              v-if="koefsDate[item.split(':')[0]] < 0">mdi-arrow-down
                      </v-icon>
                    </div>
                  </template>
                </v-select>
              </div>
              <span class="high-demand"
                    v-if="calculatedProps.koef > 1 && calculatedProps.koefObj.titleSmall && $vuetify.breakpoint.width > 600">{{
                  calculatedProps.koefObj.titleSmall
                }}</span>
              <span class="discount"
                    v-if="calculatedProps.koef < 1  && $vuetify.breakpoint.width > 600">{{
                  $store.state._(`Вам повезло, низкий спрос! Дешевле на`)
                }} {{
                  Math.abs(calculatedProps.koef * 100 - 100)
                }}%</span>
              <v-text-field
                  class="promo--tst"
                  autocomplete="off"
                  v-model="options.promo"
                  outlined
                  rounded
                  :success-messages=" options.promo && calculatedProps.promoInfo ? calculatedProps.promoInfo.title : ''"
                  @change="calculate"
                  :placeholder="$store.state._(`Промокод`)"/>
              <span class="high-demand" v-if="calculatedProps.promoError">{{ calculatedProps.promoError }}</span>
              <v-textarea
                  autocomplete="off"
                  outlined
                  v-model="options.comment"
                  :placeholder="$store.state._(`Комментарий к заказу`)+' ('+ $store.state._(`например, помыть кота или забрать вещи из химчистки`)+')'"
                  rows="3"
                  no-resize
                  style="border-radius: 12px;"
              />
            </v-form>
            <!-- /tst мобайл (Figma #21): повтор компактной плашки цены перед кнопкой «Заказать»,
                 сразу после поля комментария. Десктоп скрывает через .total__tst-compact{display:none}. -->
            <div class="total__tst-compact total__tst-compact--cta" v-if="!calculate_loading">
              <div class="total__tst-row">
                <span class="total__tst-sum">{{ headlineRegularPrice ? sumSeparator(headlineRegularPrice) : 0 }} {{ countrySettings.currency }}</span>
                <span v-if="calculatedProps.firstPromoAvailable" class="ceo-discount-badge total__tst-badge">{{ firstPromoBadgeText }}</span>
              </div>
              <div class="total__tst-meta">{{ calculatedProps.duration }} · {{ cleantype_options[options.type].title }} · {{ roomCountLabel }}</div>
            </div>
            <v-btn class="v-btn-main" @click="create" :loading="loading_create">
              {{ $store.state._(`Заказать`) }}<template v-if="displayTotalPay"> — {{ sumSeparator(displayTotalPay) }} {{ countrySettings.currency }}</template>
            </v-btn>
            <!-- /tst мобайл (Image #25): «или позвоните нам» + телефон города,
                 отступ 16 под кнопкой «Заказать». Зелёный круг — бренд-цвет #7BE19C
                 (как .ceo-discount-badge); десктоп скрывает через breakpoint. -->
            <a v-if="cityPhone && $vuetify.breakpoint.width < 600"
               class="tst-call" :href="'tel:' + cityPhoneHref">
              <span class="tst-call__icon">
                <v-icon class="tst-call__glyph">mdi-phone-outline</v-icon>
              </span>
              <span class="tst-call__text">
                <span class="tst-call__label">{{ $store.state._('или позвоните нам') }}</span>
                <span class="tst-call__phone">{{ cityPhone }}</span>
              </span>
            </a>
            <p class="privacy__text"><span>{{ $store.state._(`Нажимая кнопку, вы принимаете`) }}</span> <a
                :href="url + 'privacy'">{{ $store.state._(`Условия пользовательского соглашения`) }}</a>
              <span> {{ $store.state._(`и даёте согласие`) }}</span> <a :href="url + 'agreement'">{{
                  $store.state._(`на Обработку персональных данных`)
                }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <TimeDisabledModal ref="TimeDisabledModal" @close="onTimeDisabledModalClose"/>
  </div>
</template>

<script>
import {Server} from "@/server";
import Popup from "@/components/Popup";
import PopupRef from "./PopupRef";
import TimeDisabledModal from "@/components/TimeDisabledModal.vue";
import AdditionalService from "@/components/calc_components/AdditionalService";
import globalMixins from "@/globalMixins";

const server = new Server()
export default {
  name: 'CalculatorTst',
  components: {AdditionalService, TimeDisabledModal, PopupRef, Popup},
  mixins: [globalMixins],
  data() {
    let isCottage = window.path ? window.path.indexOf('/cottage') === 0 : false;
    let getParams = new URLSearchParams(location.search);
    let router_type = getParams.get('type') || 'standart';
    let router_rooms = getParams.get('rooms') || (this.isCottage ? '5' : '1');
    let router_promo = getParams.get('promo') || getParams.get('p') || '';
    let phone = getParams.get('phone') || getParams.get('f') || '';
    // let queryParams = location.search ? location.search.split('&') ? location.search.split('&') : location.search : null;

    // let router_type = queryParams && queryParams.find(el => el.includes('type')) ? queryParams.find(el => el.includes('type')).split('=')[1] : 'standart';

    // let router_rooms = queryParams ? queryParams.find(el => el.includes('rooms')) ? queryParams.find(el => el.includes('rooms')).split('=')[1] : '1' : '1'
    // let router_promo = queryParams ? queryParams.find(el => el.includes('promo')) ? queryParams.find(el => el.includes('promo')).split('=')[1] : '' : ''
    // if (!router_promo) router_promo = queryParams ? queryParams.find(el => el.includes('p')) ? queryParams.find(el => el.includes('p')).split('=')[1] : '' : ''
    if (!router_promo && window.promo) router_promo = window.promo;
    // console.log({router_type, router_rooms, router_promo, queryParams});
    let types = {
      standart: {
        title: this.$store.state._(`Регулярная`),
        tip: this.$store.state._(`Поддержание уюта и чистоты в вашем доме`)
      },
      general: {
        title: this.$store.state._(`Генеральная`),
        tip: this.$store.state._(`Подходит, если давно не убирались, была вечеринка или сменились жильцы`)
      },
      remont: {
        title: this.$store.state._(`После ремонта`),
        tip: this.$store.state._(`Поставим финальную точку в ремонте — очистим квартиру от строительной пыли и пятен`)
      },
    };
    let typesNames = Object.keys(types);
    let type = types[router_type] ? router_type : 'standart';
    return {
      menu_date: false,
      loading_create: false,
      showedAll: !this.isCottage,
      order_step: 0,
      reqNum: 0,
      datepicker: false,
      room_options: {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5+',
      },
      cleantype_options: types,
      additional_services: [],
      dry_cleaning_services: [],
      options: {
        address: {flattype: router_rooms, wcNum: 1},
        datetimecleanObj: {time: '', date: ''},
        client: {phone},
        type: type,
        regular: '',
        promo: router_promo,
        him: 0,
        services: {} //{count, him_koja, name}
      },
      user: {},
      flatSize: {},
      times: [],
      popupOpened: false,
      koefs: {},
      koefsDate: {},
      orderInfo: {},
      localStorageKey: 'form' + (this.isCottage ? '_cottage' : ''),
      calculatedProps: {},
      worktime: {},
      countrySettings: {},
      citySettings: {},
      slideNum: typesNames.indexOf(type),
      url: null,
      datetimeProps: {
        dateSlots: [''],
        timeSlots: []
      },
      timeError: '',
      timeDisabledModalOpened: false,
      calculate_date_loading: false,
      calculate_loading: false,
      selected_dry_service: '',
      dryCleaningServicesEnabled: 0,
      isReducedFlow: false,
    }
  },
  methods: {
    applyCleanType(typeNum) {
      this.order_step = 0
      this.options.type = Object.keys(this.cleantype_options)[typeNum];
      let today = new Date()
      this.calculate()
    },
    chooseTime(slot) {
      if (slot.disabled) {
        this.$refs.TimeDisabledModal.open();
        this.timeDisabledModalOpened = true;
      } else {
        this.options.datetimecleanObj.time = slot.time;
        this.calculate();
      }
    },
    getServices(getFromStorage = true) {
      server.request('order/services', {all: 1}, (data) => {
        this.dryCleaningServicesEnabled = +data.dry_enabled;
        this.additional_services = Object.entries(data.response).filter(([key, obj]) => {
          if (!isNaN(Number(key))) return obj;
        }).map(([key, obj]) => obj);
        if (this.dryCleaningServicesEnabled) {
          this.dry_cleaning_services = Object.entries(data.response).filter(([key, obj]) => {
            if (isNaN(Number(key))) return obj;
          }).map(([key, obj]) => obj);
        }

        this.url = data.url
        if (data.rooms) this.room_options = data.rooms;
        if (data.flatSize) this.flatSize = data.flatSize;
        this.additional_services.forEach(el => {
          this.options[el.form_name] = parseInt(el.form_value)
        })
        if (getFromStorage && localStorage.getItem(this.localStorageKey)) {
          let params = JSON.parse(localStorage.getItem(this.localStorageKey));
          for (let i in params) {
            if (['promo', 'datetimecleanObj', 'address', 'type'].includes(i)) continue;
            this.options[i] = params[i];
          }
          // this.options.promo = '';
          // this.options.datetimecleanObj = {time: '', date: ''};
          this.slideNum = Object.keys(this.cleantype_options).indexOf(this.options.type);
        }
        setTimeout(() => this.calculate(), 500);
      })
    },
    timeToMinutes(str) {
      let parts = str.split(':')
      return parseInt(parts[0]) * 60 + (parseInt(parts[1]) || 0);
    },
    showTypesModal() {
      window.showModal(document.querySelector('.modal_types_cleaning'));
    },
    calculate() {
      this.reqNum++;
      let reqNum = this.reqNum;
      this.calculate_loading = true;
      server.request('order/calculate', this.prepareParams(), (data) => {
        this.calculate_date_loading = false;
        this.calculate_loading = false;
        if (this.reqNum !== reqNum) return;
        this.datetimeProps.dateSlots = data.date_slots || [];
        this.datetimeProps.timeSlots = data.time_slots || [];
        this.isReducedFlow = !!data.isReducedFlow;
        this.calculatedProps = data.response
        if (!this.options.datetimecleanObj.date && this.datetimeProps.dateSlots.length) {
          this.options.datetimecleanObj.date = this.datetimeProps.dateSlots[1].date;
          this.calculate();
        }
        if (data.user) {
          this.user = data.user;
          this.options.client.phone = data.user.phone;
          if (data.user.name) this.options.client.name = data.user.name;
        }
        this.countrySettings = data.country
        this.citySettings = data.city || {}
        let worktime_from = this.timeToMinutes(data.city.worktime_from)

        let worktime_to = this.timeToMinutes(data.city.worktime_to)

        for (let i = worktime_from; i <= worktime_to; i = i + 30) {
          let hour = Math.floor(i / 60) < 2 ? '0' + Math.floor(i / 60) : Math.floor(i / 60);
          let minutes = i % 60 < 2 ? '0' + i % 60 : i % 60;
          this.times.push((hour === 24 ? '00' : hour) + ':' + minutes)
        }
        this.$forceUpdate();
      }, () => {
        this.calculate_date_loading = false;
        this.calculate_loading = false;
      })
    },
    prepareParams() {
      let params = {...this.options}
      params.address.wcNum = params['address.wcNum'] || 1
      params.gid = '';
      try {
        params.cookies = window.document.cookie;
        params.cookies += `isNewDatetimePicker=${this.isNewDatetimePicker};`;
        params.gid = window.ga.getAll()[0].get('clientId');
      } catch (e) {
        console.warn(e)
      }
      params.yid = '';
      for (let i in window) if ((i + '').substr(0, 'yaCounter'.length) === 'yaCounter') {
        params.yid = window[i].getClientID();
      }
      if (this.$store.state.localhost) params.isNewDatetimePicker = 1;
      params.services = this.prepareServices(this.options.services);
      if (this.countSelectedDryServices()) params.himchistka = 1;
      if (params.himchistka && !+params.delivery) {
        params.delivery = 1;
        this.options.delivery = 1;
      }
      return params
    },
    create() {
      if (this.loading_create) return;
      if (this.order_step === 0 && this.$refs.form_orderInfo.validate() || this.order_step === 1) {
        this.loading_create = true
        server.request('order/create', this.prepareParams(), (data) => {
          localStorage.setItem(this.localStorageKey, '');
          this.loading_create = false
          if (typeof window.VK === 'object') window.VK.Goal('conversion', {value: data.response.total})
          if (typeof window.trackYm === 'function') window.trackYm('Calc_Order')
          if (typeof window.fbq === 'function') window.fbq('track', 'Purchase', {
            value: data.response.total,
            currency: 'RUB'
          });
          try {
            if (typeof window.dataLayer === 'object') window.dataLayer.push({'event': 'sendform'});
          } catch (e) {
            console.log(e);
          }
          location.href = this.url + 'order';
        }, (data) => {
          alert(data.error || this.$store.state._(`Не получилось оформить заказ`))
          this.loading_create = false
        })
      }
    },
    onDateChange() {
      this.calculate_date_loading = true;
      if (this.isNewDatetimePicker) this.options.datetimecleanObj.time = '';
      else this.menu_date = false;
      // setTimeout(() => {
      //   this.$refs.time_select.$el.querySelector('.v-input__slot').click();
      // }, 20)
    },
    selectDateMobile(date) {
      this.options.datetimecleanObj.date = date;
      this.options.datetimecleanObj.time = '';
      this.calculate_date_loading = true;
      this.calculate();
    },
    onPhoneFocus() {
      if (this.$store.state.phone_placeholder[1] === '7' && !this.options.client.phone.length) {
        this.options.client.phone = '+7 (';
      }
    },
    clearForm() {
      let tempForm = {...this.options};
      this.options = {
        client: {phone: ''},
        type: tempForm.type,
        address: {flattype: tempForm.address.flattype, wcNum: 1},
        datetimecleanObj: {time: '14:00'},
        services: {},
        him: 0,
      };
      this.getServices(false);
    },
    onTimeDisabledModalClose() {
      this.timeDisabledModalOpened = false;
    },
    onDryServiceSelected(service_key) {
      this.selected_dry_service = service_key;
    },
    countSelectedDryServices() {
      let dry_service_count = 0;
      this.dry_cleaning_services.forEach((dry_cleaning_service) => {
        if (dry_cleaning_service && dry_cleaning_service.items) {
          let dry_service_items_count = 0;
          dry_cleaning_service.items.forEach(item => {
            if (+this.options.services[item.form_name]) {
              dry_service_items_count++;
            }
          });
          if (dry_service_items_count) dry_service_count++;
        }
      })
      return dry_service_count;
    }
  },
  computed: {
    // /tst phone field: "+7" is a separate prefix segment, so the input itself
    // holds only the part after "+7 ". The stored value (options.client.phone)
    // stays the full "+7 (…)" string for backend compatibility.
    phoneProxy: {
      get() {
        return (this.options.client.phone || '').replace(/^\+7\s*/, '');
      },
      set(val) {
        let digits = (val || '').replace(/\D/g, '');
        this.options.client.phone = digits ? this.$store.state.checkPhone('+7 ' + val) : '';
      }
    },
    phoneMaskTst() {
      // store mask without the leading "+7 " country prefix
      return this.$store.state.setMask(this.options.client.phone).replace(/^\+\d+\s*/, '');
    },
    phonePlaceholderTst() {
      // only the parentheses are drawn, per design
      return '(   )';
    },
    // /tst мобайл (Image #25): телефон города для блока «или позвоните нам».
    cityPhone() {
      return (this.citySettings && this.citySettings.phone) || '';
    },
    cityPhoneHref() {
      return (this.cityPhone || '').replace(/[^+\d]/g, '');
    },
    // Price shown on the «Заказать» button — totalPay minus the first-order
    // promo preview (matches the reference ceo-form on cleanbros.ru/tst).
    displayTotalPay() {
      const base = this.calculatedProps.totalPay;
      if (!base || !this.calculatedProps.firstPromoAvailable) return base;
      const percent = this.calculatedProps.firstPromoPercent || 0;
      const sum = this.calculatedProps.firstPromoDiscount || 0;
      return Math.max(0, Math.round(base * (100 - percent) / 100) - sum);
    },
    // CLBP-10: «основная» (заголовочная) цена в компактной плашке показывает
    // регулярную стоимость без скидки первого заказа (totalCost), а сама скидка
    // остаётся отдельным бейджем «-N% первый заказ». Итоговая цена к оплате
    // (displayTotalPay) уходит на кнопку «Заказать». Когда скидки нет — обе совпадают.
    headlineRegularPrice() {
      const cost = +this.calculatedProps.totalCost;
      if (this.calculatedProps.firstPromoAvailable && cost > +this.displayTotalPay) {
        return this.calculatedProps.totalCost;
      }
      return this.displayTotalPay;
    },
    // Green first-order discount badge text in the «К оплате» panel.
    firstPromoBadgeText() {
      const percent = this.calculatedProps.firstPromoPercent;
      const sum = this.calculatedProps.firstPromoDiscount;
      const currency = this.countrySettings && this.countrySettings.currency || '';
      if (percent) return '-' + percent + '% ' + this.$store.state._('первый заказ');
      if (sum) return '-' + this.sumSeparator(sum) + ' ' + currency + ' ' + this.$store.state._('первый заказ');
      return this.$store.state._('Скидка на первый заказ');
    },
    // /tst мобайл мета-строка: «N комната/комнаты/комнат» по числу комнат.
    roomCountLabel() {
      const n = +this.options.address.flattype || 1;
      const label = this.room_options[n] || n;
      const word = n === 1 ? 'комната' : (n >= 2 && n <= 4 ? 'комнаты' : 'комнат');
      return label + ' ' + this.$store.state._(word);
    },
    dry_service() {
      let minPriceObj = this.dry_cleaning_services.length ? this.dry_cleaning_services[0] : {};
      for (let i in this.dry_cleaning_services) {
        if (+this.dry_cleaning_services[i].price_from < +minPriceObj.price_from) {
          minPriceObj = this.dry_cleaning_services[i];
        }
      }
      return {
        title: 'Химчистка',
        form_name: 'him',
        price_from: minPriceObj.price_from || 0,
        form_type: 'checkbox',
        items: minPriceObj.items || [],
      }
    },

    // dateValue() {
    //   return isNewDatetimePicker ? options.datetimecleanObj.date && options.datetimecleanObj.time : options.datetimecleanObj.date ? `${new Date(options.datetimecleanObj.date).toLocaleDateString($store.state.local, {
    //     month: 'short', day: 'numeric', weekday: 'short' })}${isNewDatetimePicker ? `, ${$store.state._('в')} ${options.datetimecleanObj.time}` : ''}` : ''
    // },
    availableTimes() {
      let now = new Date();
      let nowDate = now.toISOString().split('T');
      if (this.options.datetimecleanObj.date && Date.parse(this.options.datetimecleanObj.date) === Date.parse(nowDate[0])) {
        let curTime = nowDate[1].slice(0, 2);
        return this.times.filter(time => time.split(':')[0] * 1 > (curTime * 1) + 2);
      }
      return this.times;
    },
    isNewDatetimePicker() {
      return this.datetimeProps.dateSlots && this.datetimeProps.dateSlots.length;
    },
    timeSlots() {
      if (!this.datetimeProps.timeSlots) return [];
      return [...this.datetimeProps.timeSlots[0], ...this.datetimeProps.timeSlots[1]];
    },
    isCottage() {
      return window.path && window.path.indexOf('/cottage') === 0;
    }
  },
  watch: {
    options: {
      deep: true,
      handler() {
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.options));
      }
    },
    menu_date(newVal) {
      if (newVal && this.$vuetify.breakpoint.width < 768 && this.isNewDatetimePicker) {
        document.querySelector('body').classList.add('date-picker-opened');
      }
      if (!newVal) document.querySelector('body').classList.remove('date-picker-opened');
    }
  },
  mounted() {
    let openPopup = true;
    this.$eventBus.$on('friendPromo', (data) => {
      this.options.client.phone = data.phone
      this.calculate();
    });
    this.$eventBus.$on('getPromo', (data) => {
      this.options.client.phone = data.phone
      this.options.promo = 'firstpop'
      this.calculate();
    })
    if (this.options.promo && +this.options.promo && this.options.promo.length === 11) {
      this.$refs.PopupRef.opened = true;
    } else if (window.cityCode !== 'pshk' && window.promoFirstpop && openPopup) {
      if (this.$vuetify.breakpoint.width < 600) {
        setTimeout(() => {
          if (!this.options.promo && !this.popupOpened && !this.user.phone) {
            this.$refs.Popup.opened = true;
            this.popupOpened = true;
          }
        }, 45 * 1000);
      } else {
        document.body.onmouseleave = () => {
          if (!this.options.promo && !this.popupOpened && !this.user.phone) {
            this.$refs.Popup.opened = true;
            this.popupOpened = true;
          }
        }
      }
    }
    this.getServices()
    // this.calculate()

    // /tst: coordinate the two fixed bottom overlays so only one shows at a time.
    // While the calculator is on screen, hide the global floating bar and show the
    // price bar; off screen, the inverse (CSS gates both to mobile breakpoints).
    if (this.$refs.calculator && typeof IntersectionObserver !== 'undefined') {
      this._tstCalcObserver = new IntersectionObserver(([entry]) => {
        document.body.classList.toggle('tst-calc-in-view', entry.isIntersecting);
      }, {threshold: 0});
      this._tstCalcObserver.observe(this.$refs.calculator);
    }
  },
  beforeDestroy() {
    if (this._tstCalcObserver) {
      this._tstCalcObserver.disconnect();
      this._tstCalcObserver = null;
    }
    document.body.classList.remove('tst-calc-in-view');
  },
}
</script>
<style lang="scss">
.date-picker-opened {
  overflow: hidden;
}

/* /tst (Image #5): убираем разделительную линию предыдущего блока, но только
   когда следующий блок — наш калькулятор. :has() самоограничивает правило
   секцией, внутри которой есть .calculator--tst, поэтому на других страницах/
   секциях граница остаётся. */
.section-with-tabs-outer:has(.calculator--tst) .cleanings-description-outer {
  border-bottom: none !important;
}

/* /tst variant-only design overrides (scoped via .calculator--tst so the
   production Calculator and other variants are unaffected). */
.calculator--tst {
  /* «Очистить» — белый фон, как у остальных кнопок */
  .additional-services .clear-btn.v-btn {
    background: #FFFFFF !important;
    border: none;
    color: #333333;
    box-shadow: none;
  }

  /* Компактная мобайл-плашка цены (Figma) — на десктопе скрыта,
     включается в @media (max-width:600px). */
  .total__tst-compact {
    display: none;
  }

  /* Зелёный бейдж скидки на первый заказ (как на reference ceo-form). */
  .ceo-discount-badge {
    display: inline-block;
    background: #7BE19C;
    border-radius: 12px;
    /* Figma: горизонтальный паддинг бейджа 100px на десктопе, 33px на мобайле
       (мобайл-оверрайд для .total__tst-badge в @media max-width:600px). */
    padding: 7px 100px;
    margin-bottom: 12px;
    font-size: 13px;
    line-height: 140%;
    color: #333333;
    white-space: nowrap;
  }

  /* /tst мобайл (Image #25): «или позвоните нам» под CTA, отступ 16,
     по центру. Зелёный круг 36×36 (#7BE19C), внутри контурная иконка
     телефона 18.72px (не залитая). */
  .tst-call {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 16px;
    text-decoration: none;
    color: inherit;
  }
  .tst-call__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #7BE19C;
  }
  .tst-call__glyph.v-icon {
    font-size: 18.72px;
    color: #333333;
  }
  .tst-call__text { display: flex; flex-direction: column; text-align: center; }
  /* call us — Image #2: Gerbera 400 / 14 / 140% */
  .tst-call__label {
    font-family: Gerbera, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #B5B0AC;
  }
  /* phone — Image #3: Gerbera-Medium (вес 500) / 16 / 140% / center */
  .tst-call__phone {
    font-family: Gerbera, sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;
    text-align: center;
    color: #333333;
  }

  /* /tst (Image #4): privacy-текст скрыт на мобайле (десктоп — без изменений). */
  @media screen and (max-width: 600px) {
    .privacy__text { display: none; }
  }

  .order-info {
    /* телефон: +7 отдельным сегментом + разделительная полоса */
    .phone--tst {
      .v-input__prepend-inner {
        margin-top: 0;
        align-self: stretch;
        display: flex;
        align-items: center;
        padding: 0 14px 0 6px;
        margin-right: 12px;
        border-right: 1px solid #DFDCDA;
      }

      .phone--tst__prefix {
        font-size: 16px;
        line-height: 1;
        color: #333333;
      }
    }
  }
}

/* /tst-вариант: убрать окантовку полей ввода. Базовое production-правило
   `.calculator .page-content .side-wrapper .order-info … fieldset` имеет
   специфичность (0,5,1) и перебивало прежний `.calculator--tst .order-info …`
   (0,3,1). Здесь (0,6,1) — выигрывает, не затрагивая обычный калькулятор. */
.calculator.calculator--tst .page-content .side-wrapper .order-info .v-text-field fieldset,
.calculator.calculator--tst .page-content .side-wrapper .order-info .v-textarea fieldset {
  border: none;
}

/* /tst: «ТИП УБОРКИ» прижат вправо в production-правиле
   `.calculator .page-content .cleantypes__title { margin-left:auto; max-width:350px }`
   (0,3,0). Здесь (0,4,0) — выигрываем и выравниваем заголовок по левому краю
   колонки, т.е. по левому краю первой кнопки-pill. */
.calculator.calculator--tst .page-content .cleantypes__title {
  margin-left: 0;
  max-width: none;
}

/* /tst десктоп (≥601px) — на мобайле эти блоки скрыты/переопределены ниже. */
@media (min-width: 601px) {
  /* «ТИП УБОРКИ» прижат вправо (правый край совпадает с «Очистить»); зазор до
     блока «КОЛИЧЕСТВО КОМНАТ» слева растёт с шириной экрана — как в Figma.
     Cottage не трогаем (там типы — единственный блок, во всю ширину). */
  .calculator--tst .page-content .flat-options:not(.cottage-options) > .cleantypes {
    flex-grow: 0 !important;
    margin-left: auto;
  }

  /* Плашка «-15% первый заказ»: во всю ширину блока цены, без хардкод-паддинга
     100px, вертикальные отступы 16px сверху и снизу. */
  .calculator.calculator--tst .total > .ceo-discount-badge {
    display: block;
    padding: 7px 0;
    margin: 16px 0;
    text-align: center;
  }

  /* 30px от карточки цены до поля телефона (база даёт margin-bottom:40px). */
  .calculator.calculator--tst .page-content .side-wrapper .total {
    margin-bottom: 30px;
  }
}

/* /tst планшет (601–1024px, цель — 768px портрет). Базовый брейкпоинт компонента
   — 600px, поэтому планшет попадает в десктопную ветку; ниже — отличия, которые
   подтверждены в браузере на 768px. */
@media (min-width: 601px) and (max-width: 1024px) {
  /* Одноколоночная раскладка на всём планшете (вкл. 960–1024px), как на 768px:
     карточка цены и форма заказа идут ПОД калькулятором, а не сбоку. База
     включает второй столбец с min-width:960px (.page-content-wrapper → flex-row);
     до 1024px это «как на 1440», что не нужно — возвращаем колонку. Десктоп
     ≥1025px не трогаем (band обрывается на 1024). */
  .calculator.calculator--tst .page-content .page-content-wrapper {
    flex-direction: column;
    align-items: center;
  }

  /* «ТИП УБОРКИ»: блок уже прижат вправо (правило ≥601 выше). На 768px три
     pill-кнопки не помещаются в одну строку рядом с «КОЛИЧЕСТВОМ КОМНАТ» —
     выравниваем их по правому краю, чтобы перенесённая последняя кнопка уходила
     на новую строку, тоже прижатая вправо (как на десктопе, когда умещаются). */
  .calculator--tst .flat-options:not(.cottage-options) > .cleantypes .ceo-types-grid {
    justify-content: flex-end;
  }

  /* Не даём блоку «ТИП УБОРКИ» расшириться настолько, чтобы три pill-кнопки
     встали в одну строку: при одной строке кнопки занимают весь блок (первая
     у левого края), а капшен остаётся прижат вправо на 301px и «уезжает» к
     центру (баг на ~840–1024px после одноколоночной раскладки выше). Ограничиваем
     блок шириной 768px-раскладки (418px) — кнопки всегда переносятся в 2 строки
     (как на 768px), и капшен (301px, прижат вправо, см. ниже) совпадает с левым
     краем первой кнопки. */
  .calculator--tst .flat-options:not(.cottage-options) > .cleantypes {
    max-width: 418px;
  }

  /* Капшен «ТИП УБОРКИ» выравниваем по левому краю первой кнопки. Кнопки прижаты
     вправо (см. выше), а строка «Регулярная + Генеральная» имеет ширину ≈301px,
     поэтому её левый край (= левый край первой кнопки) отстоит на 301px от
     правого края блока. Даём капшену бокс такой же ширины, прижатый вправо
     (margin-left:auto): его правый край совпадает с правым краем блока, левый —
     с левым краем первой кнопки. Блок остаётся 418px, перенос строк не меняется. */
  .calculator--tst .flat-options:not(.cottage-options) > .cleantypes .cleantypes__title {
    width: 301px;
    max-width: 100%;
    margin-left: auto;
    text-align: left;
  }

  /* Карточка цены и форма заказа лежат в .side-wrapper — flex-элементе колонки
     (.page-content-wrapper: column + align-items:center) без заданной ширины,
     поэтому он подгоняется под контент и центрируется (~515px). Длинная строка
     «Высокий спрос!» при выборе времени делала его самым широким элементом и
     растягивала колонку на всю ширину (768px) — карточка «прыгала» при
     ре-рендере. Фиксируем ширину колонки на базовые 515px: размер не меняется
     между состояниями, а текст «Высокий спрос!» переносится внутри карточки. */
  .calculator--tst .page-content-wrapper > .side-wrapper.total-wrapper {
    width: 515px;
    max-width: 100%;
  }
}

.calculator {
  .value-text-field.theme--light.v-input--is-disabled {
    color: #333333;

    input {
      color: #333333;
    }
  }

  .collapse-btn-wrapper {
    padding: 24px 34px 32px;
  }

  .page-content .flat-options.cottage-options {
    column-gap: 30px;
    margin-bottom: 40px;

    .cleantypes__title, .cleantypes-options {
      margin-left: 0;
      width: 100%;
      max-width: 100%;
    }

    .sqr-wrapper {
      max-width: 168px;
      width: 100%;
      align-items: flex-end;
    }
  }
}

.v-menu__content.datetime-modal-content {
  left: 0 !important;
  width: 100%;
  height: 100vh;
  border-radius: 0;
  max-width: 100%;
  position: fixed;
  top: 0 !important;
}

.time-picker-container {
  width: 100%;
  padding: 12px;

  .time-slot-items {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 24px 8px;
    margin-bottom: 33px;

    .time-slot-item-container {
      position: relative;
      cursor: pointer;

      .time {
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #C8C6C6;
        border-radius: 8px;
        font-size: 15px;
        line-height: 140%;

        &.selected {
          background: #333333;
          color: #FFFFFF;
        }
      }

      .percent {
        text-align: center;
        position: absolute;
        width: 100%;
        top: 44px;
        font-size: 11px;
        line-height: 120%;
      }
    }
  }

  .time-picker-button {
    justify-content: space-between;
    letter-spacing: normal;

    .v-btn__content {
      font-size: 14px;
    }

    .old-sum {
      margin-left: auto;
      margin-right: 8px;
      color: #B5B0AC;
      text-decoration: line-through;
    }
  }
}

.mobile-datetime-picker {
  background: #FFFFFF;
  width: 100%;
  height: 100%;
  padding: 40px 20px 0;
  display: flex;
  flex-direction: column;
  position: relative;

  &-close.v-btn {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .picker-label {
    margin-bottom: 8px;
    display: block;
    font-size: 18px;
    line-height: 130%;
  }

  .date-slots-container::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .date-slots-container {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .date-slots-container {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    margin-bottom: 40px;
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;

    .date-slot {
      min-width: 46px;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      border: 1px solid #C8C6C6;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 15px;

      &.selected {
        background: #333333;

        span {
          color: #FFFFFF;
        }
      }

      span {
        line-height: 100%;
        height: 15px;
        display: block;
        text-align: center;
      }
    }
  }

  .time-picker-container {
    padding: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &-actions {
    position: fixed;
    width: calc(100% - 40px);
    bottom: 140px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    margin-top: auto;
    z-index: 1;
  }
}

.v-date-picker-table__events {
  margin-bottom: -3px !important;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(0, 2%, 90%);
  }
  100% {
    background-color: hsl(200, 14%, 96%);
  }
}

.skeleton-loader {
  animation: skeleton-loading 1s linear infinite alternate;
  border: none !important;
}

@media screen and (max-width: 600px) {
  .calculator {
    .page-content {
      .flat-options.cottage-options {
        .cleantypes__title, .cleantypes-options {
          margin-left: 0;
          width: 100%;
          max-width: 100%;
          margin-bottom: 28px;
        }

        .sqr-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          max-width: 100%;
          width: 100%;

          .sqr__value {
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
/* Type-buttons as pills — ported from the reference ceo-form (OrderForm.vue),
   which is what cleanbros.ru/tst renders. */
.ceo-types-grid {
  display: flex;
  flex-wrap: wrap;
  /* Figma: 8px между кнопками типа по горизонтали на десктопе (4px на мобайле).
     По вертикали (между рядами при переносе) 8px — выравниваем с эталонной
     ceo-form (OrderForm), где gap:8px по обеим осям. flex-start вместо
     space-between — иначе зазор зависит от ширины и даёт ~16px. */
  justify-content: flex-start;
  column-gap: 8px;
  row-gap: 8px;
  width: 100%;
}

/* Капшены «КОЛИЧЕСТВО КОМНАТ» / «ТИП УБОРКИ» разной высоты (у первого —
   иконка-тултип), из-за чего ряды кнопок начинались на разной высоте.
   Выравниваем высоту обоих заголовков, чтобы кнопки встали на одну линию. */
.calculator--tst .flat-options .options__title {
  display: flex;
  align-items: center;
  min-height: 24px;
}

/* Элемент несёт оба класса `cleantypes-options ceo-types-grid`. Карусельное
   production-правило `.calculator .page-content .cleantypes-options` (0,3,0)
   навязывает overflow:hidden + border-radius:50px + max-width:350px +
   margin-left:auto и обрезает pill-кнопки. Перебиваем (0,4,0 со scoped-attr),
   только в /tst-варианте. */
.calculator--tst .cleantypes-options.ceo-types-grid {
  overflow: visible;
  max-width: none;
  border-radius: 0;
  margin-left: 0;
}

.ceo-type-btn {
  flex: 0 0 auto;
  box-sizing: border-box;
  min-height: 50px;
  padding: 8px 16px;
  white-space: nowrap;
  border: 1px solid transparent;
  border-radius: 999px;
  background: #FFFFFF;
  color: #333333;
  font-size: 15px;
  line-height: 140%;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  &:hover {
    border-color: #333333;
  }

  &--selected {
    background: #333333;
    color: #FFFFFF;
    border-color: #333333;

    .ceo-type-btn__hint {
      filter: invert(1) brightness(2);
    }
  }

  &__hint {
    width: 20px;
    height: 20px;
    cursor: pointer;
    flex: 0 0 20px;
  }
}

/* Мобайл (Figma): «ТИП УБОРКИ» сверху, «КОЛИЧЕСТВО КОМНАТ» — под ним.
   В DOM .room-number идёт первым, поэтому переставляем порядок флекс-колонки
   (.flat-options уже flex-direction:column на ≤600px из styles.scss). */
@media (max-width: 600px) {
  .calculator--tst .flat-options {
    .cleantypes {
      order: 1;
    }

    .room-number {
      order: 2;
      /* Figma (мобайл): 16px над «КОЛИЧЕСТВО КОМНАТ». */
      margin-top: 16px;
    }
  }

  /* Figma (мобайл): 16px от верхнего края карточки до «ТИП УБОРКИ».
     База даёт .page-content { padding-top: 30px } — на мобайле снижаем до 16. */
  .calculator--tst .page-content {
    padding-top: 16px;
  }

  /* Кнопки типа пакуются влево (flex-start задаётся в .ceo-types-grid).
     Зазор 8px по обеим осям, как в эталонной ceo-form (OrderForm). */
  .calculator--tst .cleantypes-options.ceo-types-grid {
    gap: 8px;
  }

  /* Figma: 4px между кнопками-комнатами на мобайле (8px на десктопе из базы).
     Уходим от space-between + margin-right к flex-start + gap, чтобы зазор был
     ровно 4px. Спецификация (0,5,0 со scoped-attr) перебивает базу (0,4,0). */
  .calculator--tst .page-content .flat-options .room-number-options {
    justify-content: flex-start;
    gap: 4px;
  }

  .calculator--tst .page-content .flat-options .room-number-options__option {
    margin-right: 0;
  }

  /* Figma: горизонтальный паддинг зелёного бейджа на мобайле 33px. */
  .calculator--tst .total__tst-badge {
    padding-left: 33px;
    padding-right: 33px;
  }

  /* Figma #21: повтор плашки цены перед кнопкой «Заказать» — зазоры от поля
     комментария сверху и до кнопки снизу. */
  .calculator--tst .total__tst-compact--cta {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  /* Figma (мобайл): блок цены идёт сразу под блоком «КОЛИЧЕСТВО КОМНАТ»,
     перед «ДОПОЛНИТЕЛЬНЫЕ УСЛУГИ». В разметке цена (.total) и форма заказа
     (.order-info) лежат в .side-wrapper, а типы/комнаты и услуги — в
     .options-wrapper. Распаковываем обе обёртки в общий флекс
     .page-content-wrapper (display:contents) и расставляем порядок. */
  .calculator--tst .options-wrapper,
  .calculator--tst .side-wrapper.total-wrapper {
    display: contents;
  }

  .calculator--tst .flat-options,
  .calculator--tst .additional-services,
  .calculator--tst .total,
  .calculator--tst .order-info {
    align-self: stretch;
    box-sizing: border-box;
  }

  .calculator--tst .flat-options {
    order: 1;
  }

  .calculator--tst .total {
    order: 2;
    /* .side-wrapper держал боковые отступы 0 30px — возвращаем их карточке
       цены, т.к. при display:contents бокс обёртки исчезает. */
    margin-left: 30px;
    margin-right: 30px;
  }

  .calculator--tst .additional-services {
    order: 3;
  }

  .calculator--tst .order-info {
    order: 4;
    padding-left: 30px;
    padding-right: 30px;
  }

  /* CLBP-10: над полем телефона — 28px бежевого зазора, ниже низа белой
     карточки опций (а не белым паддингом внутри карточки, как было раньше).
     Зазор держит padding-top бежевой секции .order-info: 20px + 8px
     собственного верхнего инсета первого .v-input (outlined-поле) = 28px
     видимого зазора от низа белой карточки до рамки поля телефона.
     padding-bottom обёртки «Свернуть» оставляем штатным — это низ белой карточки. */
  .calculator--tst .additional-services .collapse-btn-wrapper {
    padding-bottom: 28px;
  }
  .calculator.calculator--tst .page-content .side-wrapper .order-info {
    padding-top: 20px;
  }
  .calculator.calculator--tst .page-content .side-wrapper .order-info .v-form > .v-input:first-child {
    margin-top: 0;
    padding-top: 0;
  }

  /* Figma (мобайл): вместо белой карточки «К оплате» — плоская плашка на
     бежевом фоне: крупная итоговая сумма (с учётом промо) + зелёный бейдж в
     одну строку, под ними мета-строка «время · тип · комнаты». Десктопные
     части карточки прячем. Высокая специфичность — перебиваем prod-правило
     `.calculator .page-content .side-wrapper .total` (0,4,0), иначе остаётся
     белый фон/паддинги/отступы карточки. */
  .calculator.calculator--tst .page-content .side-wrapper .total {
    background: transparent;
    border-radius: 0;
    padding: 0;
    /* Figma: 20px от ряда кнопок-комнат до блока цены. Весь зазор держит этот
       margin-top — нижние отступы flat-options/room-number обнулены ниже. */
    margin-top: 20px;
    /* Figma: 28px от мета-строки цены до «ДОПОЛНИТЕЛЬНЫЕ УСЛУГИ». */
    margin-bottom: 28px;
  }

  /* Обнуляем нижние отступы, формировавшие лишний зазор кнопки→цена
     (.flat-options margin-bottom:15 + .room-number-options margin-bottom:15).
     Перебиваем prod (0,3,0)/(0,4,0). */
  .calculator.calculator--tst .page-content .flat-options {
    margin-bottom: 0;
  }

  .calculator.calculator--tst .page-content .flat-options .room-number-options {
    margin-bottom: 0;
  }

  /* Figma: 8px от капшена «КОЛИЧЕСТВО КОМНАТ» до ряда кнопок. */
  .calculator.calculator--tst .page-content .flat-options .room-number .options__title {
    margin-bottom: 8px;
  }

  /* Figma (мобайл): 8px от капшена «ТИП УБОРКИ» до ряда кнопок-типов. */
  .calculator.calculator--tst .page-content .flat-options .cleantypes .options__title {
    margin-bottom: 8px;
  }

  .calculator--tst .total > .total__desc,
  .calculator--tst .total > .selected-services,
  .calculator--tst .total > .discount-wrapper,
  .calculator--tst .total > .total-sum-wrapper,
  .calculator--tst .total > .duration-wrapper,
  .calculator--tst .total > .ceo-discount-badge {
    display: none;
  }

  /* Figma #23: блок «Высокий спрос» — отдельная белая карточка под плашкой цены.
     База красит его в бежевый (#F4F0ED = цвет фона), из-за чего он «исчезал».
     Перебиваем базу высокой специфичностью (0,6,0 + scoped-attr). */
  .calculator.calculator--tst .page-content .side-wrapper .total > .high-demand-wrapper {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 16px 20px;
    margin-top: 20px;
    font-size: 15px;
    line-height: 140%;
    color: #333333;
  }

  .calculator.calculator--tst .page-content .side-wrapper .total > .high-demand-wrapper span {
    display: block;
    margin-top: 4px;
    color: #B5B0AC;
  }

  .calculator--tst .total__tst-compact {
    display: block;
  }

  .calculator--tst .total__tst-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
  }

  .calculator--tst .total__tst-sum {
    font-size: 38px;
    line-height: 100%;
    color: #333333;
    white-space: nowrap;
  }

  .calculator--tst .total__tst-badge {
    margin-bottom: 0;
  }

  .calculator--tst .total__tst-meta {
    margin-top: 12px;
    font-size: 14px;
    line-height: 140%;
    color: #B5B0AC;
    text-transform: lowercase;
  }
}
</style>
